

































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import ModalView from '@/components/helper/modal-view.vue';
import Util from '@/lib/util';
import ListBase from '@/lib/listbase';

@Component({
    components: { ModalView },
    watch: {
        value: function (val) {
            let obj = (this as any);
            obj.modalShow = val;
            if (val) {
                obj.initForm();
            }
        },
        modalShow: function (val) {
            if (!val) {
                this.$emit('input', false);
            }
        }
    }
})

export default class DealersList extends ListBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    @Prop({ type: String, default: 'Venta' }) type: string;
    @Prop({ type: Object }) pagerequest: object;
    modalSetting: any = {
        entity: "dealer",
        width: "400px", 
        showForm: false,
        titleFull: 'Cifras',
        icon: 'mdi-upload',
        showFootActions: false,
        showFloatFootActions: false,
        persistent: false
    };
            
    get loading() {
        return this.$store.state.figure.loadingDealers;
    }

    get list() {
        return this.$store.state.figure.dealers;
    };

    get totalCount() {
        return this.$store.state.figure.dealers.length;
    };

    get subtitle() {
        let months = this.gCommonList('months');
        return (this.pagerequest as any).year + ' - ' + months[(this.pagerequest as any).month-1].name;
    };
            
    initForm() {
        this.modalSetting.titleFull =
            (this.type == 'Actualizados' ? 'Cifras Actualizadas' : 
            (this.type == 'Publicados' ? 'Cifras Publicadas' : 'Cifras Pendientes'));

        this.getpage();
    }

    getInitials(string) {
        return Util.getInitials(string);
    }

    async getpage() {
        await this.$store.dispatch({
            type: 'figure/getDealers',
            data: {
                year: (this.pagerequest as any).year,
                month: (this.pagerequest as any).month,
                type: this.type
            }
        });
    }

    cancel() {
        this.$emit('input', false);
    }

    mounted() {
    }

    created() {
    }
}
